import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
// import logo from "../assets/img/logo.svg";
//teste Danillo
import logo from '../assets/img/als/Logotipo-ALS.svg';
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container fluid>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-sm-end">
            <div className="social-icon" style={{marginTop: 32}}>
              <a href="https://www.linkedin.com/company/alsengenhariace/" target="_blank"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://www.instagram.com/alsengenhariace/" target="_blank"><img src={navIcon3} alt="Icon" /></a>
              <a href="https://wa.me/5585984441000?text=Ol%C3%A1!" target="_blank"><img src={navIcon4} alt="" /></a>
            </div>
            <p>Copyright 2024. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
